const Video = ({ width, height, color, ...props }) => (
  <svg
    width={width}
    height={height}
    {...props}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 40 40"
  >
    <path
      d="M36.538 6.145v4.804H3.476V6.145a3.914 3.914 0 013.913-3.914h25.242a3.913 3.913 0 013.907 3.914z"
      fill="#2D57A5"
    />
    <path
      d="M36.538 10.949v22.899a3.914 3.914 0 01-3.907 3.914H7.382a3.914 3.914 0 01-3.906-3.914V10.949h33.062z"
      fill="#fff"
    />
    <path
      d="M25.923 17.205H14.077a3.684 3.684 0 00-3.684 3.685v6.486a3.684 3.684 0 003.684 3.684h11.846a3.684 3.684 0 003.684-3.684V20.89a3.684 3.684 0 00-3.684-3.685z"
      fill="#A0CD4E"
    />
    <path
      d="M17.921 26.416v-3.204c0-.876.64-1.23 1.39-.786l2.781 1.634a.842.842 0 010 1.599l-2.78 1.57c-.78.446-1.398.084-1.391-.813z"
      fill="#fff"
    />
    <g style={{ mixBlendMode: 'multiply' }}>
      <path
        d="M7.382 37.761h2.781a3.914 3.914 0 01-3.907-3.913V6.145a3.914 3.914 0 013.914-3.914H7.39a3.914 3.914 0 00-3.914 3.914v27.703a3.914 3.914 0 003.906 3.913z"
        fill="#0E0F11"
        opacity=".25"
      />
    </g>
    <path
      d="M33.757 6.145v27.703a3.914 3.914 0 01-3.906 3.913h2.78a3.913 3.913 0 003.907-3.913V6.145a3.914 3.914 0 00-3.907-3.914h-2.78a3.914 3.914 0 013.906 3.914z"
      fill="#fff"
    />
    <path
      d="M36.538 6.145v4.804H3.476V6.145a3.914 3.914 0 013.913-3.914h25.242a3.913 3.913 0 013.907 3.914v0zM36.538 10.949v22.899a3.914 3.914 0 01-3.907 3.914H7.382a3.914 3.914 0 01-3.906-3.914V10.949h33.062z"
      stroke="#231F20"
      strokeWidth="1.39"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.923 17.205H14.077a3.684 3.684 0 00-3.684 3.685v6.486a3.684 3.684 0 003.684 3.684h11.846a3.684 3.684 0 003.684-3.684V20.89a3.684 3.684 0 00-3.684-3.685z"
      stroke="#231F20"
      strokeWidth="1.39"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.921 25.721v-3.204c0-.876.64-1.23 1.39-.786l2.781 1.634a.842.842 0 010 1.599l-2.78 1.57c-.78.446-1.398.084-1.391-.813z"
      stroke="#231F20"
      strokeWidth="1.39"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.98 6.368h8.043M18.602 6.368h4.352"
      stroke="#231F20"
      strokeWidth="2.086"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Video;
